import Color from 'color';
import { createTheme } from '@material-ui/core/styles';

import {
  primary,
  secondary,
  black,
  white,
} from './palette';

export default createTheme({
  palette: {
    background: {
      default: primary[50],
      paper: primary.A200,
    },
    primary: {
      ...primary,
      main: primary[500],
      contrastText: primary.A100,
    },
    secondary: {
      ...secondary,
      main: secondary[500],
      contrastText: secondary[50],
    },
    common: {
      black,
      white,
    },
    text: {
      primary: black,
      secondary: white,
    },
    action: {
      active: 'rgba(0, 0, 0, 0.54)',
      hover: 'rgba(0, 0, 0, 0.08)',
      hoverOpacity: 0.08,
      selected: 'rgba(0, 0, 0, 0.14)',
      disabled: 'rgba(0, 0, 0, 0.3)',
    },
  },
  typography: {
    fontSize: 13,
    allVariants: {
      color: black,
    },
    fontFamily: [
      'Sarabun',
      'Roboto',
      'Segoe UI',
      'sans-serif',
    ].join(','),
  },
  props: {
    MuiButton: {
      disableElevation: true,
      size: 'small',
    },
    MuiButtonGroup: {
      disableElevation: true,
    },
    MuiInputLabel: {
      margin: 'dense',
    },
    MuiTextField: {
      size: 'small',
      fullWidth: true,
    },
    MuiFormControl: {
      size: 'small',
      fullWidth: true,
    },
    MuiCheckbox: {
      size: 'medium',
    },
    MuiTabs: {
      TabIndicatorProps: {
        style: {
          height: 5,
          backgroundColor: secondary.A200,
        },
      },
    },
  },
  overrides: {
    MuiInputLabel: {
      root: {
        color: Color(black).alpha(0.75).toString(),
        display: 'flex',
        alignItems: 'center',
      },
      shrink: {
        color: primary[500],
        transform: 'translate(0, 1.5px) scale(0.9)',
      },
    },
    MuiFormLabel: {
      root: {
        display: 'flex',
        alignItems: 'center',
      },
    },
    MuiInput: {
      underline: {
        '&:before': {
          borderBottom: `1px solid ${Color(black).alpha(0.3).toString()}`,
        },
        '&:hover:not(.Mui-disabled):before': {
          borderBottom: `2px solid ${primary[500]}`,
        },
      },
    },
    MuiTooltip: {
      tooltip: {
        fontSize: 12,
      },
    },
    MuiTypography: {
      h6: {
        fontSize: 14,
        fontWeight: 700,
      },
    },
    MuiSelect: {
      root: {
        maxWidth: '70vw',
      },
    },
    MuiMenuItem: {
      root: {
        textOverflow: 'ellipsis',
        display: 'list-item',
      },
    },
    MuiButton: {
      outlinedPrimary: {
        '&:hover': {
          backgroundColor: Color(white).alpha(0.8).toString(),
        },
        '&:disabled': {
          borderColor: Color(primary[500]).alpha(0.5).toString(),
          '& .MuiButton-label': {
            color: Color(primary[500]).alpha(0.5).toString(),
          },
        },
      },
      containedPrimary: {
        '&:disabled': {
          backgroundColor: Color(primary[500]).alpha(0.5).toString(),
          '& .MuiButton-label': {
            color: white,
          },
        },
      },
      outlinedSecondary: {
        '&:hover': {
          backgroundColor: Color(white).alpha(0.8).toString(),
        },
        '&:disabled': {
          borderColor: Color(secondary[500]).alpha(0.5).toString(),
          '& .MuiButton-label': {
            color: Color(secondary[500]).alpha(0.5).toString(),
          },
        },
      },
      containedSecondary: {
        '&:disabled': {
          backgroundColor: Color(secondary[500]).alpha(0.5).toString(),
          '& .MuiButton-label': {
            color: white,
          },
        },
      },
    },
    MuiCheckbox: {
      root: {
        color: primary[500],
      },
    },
    MuiRadio: {
      root: {
        color: primary[500],
      },
    },
    MuiAutocomplete: {
      clearIndicator: {
        marginRight: -16,
        marginTop: -8,
        padding: 12,
      },
      popupIndicator: {
        marginRight: -8,
        marginTop: -8,
        padding: 12,
      },
      popupIndicatorOpen: {
        transform: 'none',
      },
    },
  },
});
